import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-global-fetch" id="module-global-fetch"></a>
    <h1 {...{
      "id": "windowfetchinput-init"
    }}>{`window.fetch(input, `}{`[init]`}{`)`}</h1>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Response>`}</inlineCode>{` - see `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response"
      }}>{`Response`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">{`TypeError`}</li>
    </ul>
    <ol>
      <li parentName="ol">{`when init.body is set and init.method is either "GET" or "HEAD".`}</li>
      <li parentName="ol">{`when either network error or network time-out occurs after a http request is made.`}</li>
      <li parentName="ol">{`when there is a failure in reading files in FormData during posting FormData.`}</li>
    </ol>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`input`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Request`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`either the URL string to connect with or a Request object having the URL and the init option in the below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`custom options for a HTTP request.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.method]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;GET&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the HTTP request method.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.headers]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Headers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the HTTP request headers to add.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.body]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`TypedArray`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`FormData`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the body that is included in the HTTP request body. There is a caveat for sending a FormData object. see `}<a parentName="td" {...{
              "href": "./XMLHttpRequest.md#module:global.xmlhttprequest.send"
            }}>{`XMLHttpRequest.send`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.credentials]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;omit\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`indicates whether to send cookies. Possible values and functions are as follows: "omit" : cookies are NOT sent, "same-origin" and "include" : cookies are sent.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      